import { ProductStatusEnum } from '../../ReceivementTypes'

export const BadgeByStatus = {
  [ProductStatusEnum.DIVERGENT]: {
    color: '#FFEA31',
    text: 'Divergência',
  },
  [ProductStatusEnum.CORRECT]: {
    color: '#117EFF',
    text: 'Produto Correto',
  },
  [ProductStatusEnum.WRONG]: {
    color: '#FF896E',
    text: 'Produto Errado',
  },
}
